module.exports = __webpack_public_path__ + "static/media/YF10_2.c5725417.jpg";